import { FieldTypeEnum } from '@genesislcap/foundation-comms';
/**
 * Returns a filter type based on the Grid Pro field/column type.
 * @param type - The type of the field/column
 * @returns The ag-grid filter type
 * @remarks Currently only returns agTextColumnFilter
 * @alpha
 */
export function getFilterByFieldType(type) {
    switch (type === null || type === void 0 ? void 0 : type.toLowerCase()) {
        case 'int':
        case 'long':
        case 'double':
        case 'bigdecimal':
        case 'number':
            return 'agNumberColumnFilter';
        case 'date':
        case 'datetime':
            return 'agDateColumnFilter';
        default:
            return 'agTextColumnFilter';
    }
}
/**
 * Return a column type base on each field's metadata from the selected resource.
 * @param metadataType - The type of the field/column
 * @returns the column type
 * @remarks Currently only handles numeric columns
 * @alpha
 */
export function getColumnType(metadataType) {
    switch (metadataType === null || metadataType === void 0 ? void 0 : metadataType.toLowerCase()) {
        case 'int':
        case 'long':
        case 'double':
        case 'bigdecimal':
        case 'number':
            return 'numericColumn';
        case 'date':
        case 'datetime':
            return 'dateColumn';
        default:
            return null;
    }
}
/**
 * Returns the filter params based on the Grid Pro field/column type.
 * @param type - The type of the field/column
 * @returns the filter params for the specified field type
 * @remarks Currently only returns a default filter params object, for all field types
 * @alpha
 */
export function getFilterParamsByFieldType(type) {
    switch (type) {
        case FieldTypeEnum.BOOLEAN: {
            return {
                buttons: ['reset', 'apply'],
                closeOnApply: true,
                closeOnClear: true,
                suppressAndOrCondition: true,
                filterOptions: [
                    'contains',
                    {
                        displayKey: 'true',
                        displayName: 'True',
                        predicate: (_, cellValue) => cellValue === 'true' || cellValue === true,
                        numberOfInputs: 0,
                    },
                    {
                        displayKey: 'false',
                        displayName: 'False',
                        predicate: (_, cellValue) => cellValue === 'false' || cellValue === false,
                        numberOfInputs: 0,
                    },
                    {
                        displayKey: 'true-false',
                        displayName: 'True/False',
                        predicate: (_, cellValue) => cellValue === 'true' ||
                            cellValue === true ||
                            cellValue === 'false' ||
                            cellValue === false,
                        numberOfInputs: 0,
                    },
                ],
            };
        }
        case FieldTypeEnum.DATE:
        case FieldTypeEnum.DATETIME: {
            return {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue)
                        return -1;
                    const cellValueTime = new Date(cellValue).setHours(0, 0, 0, 0);
                    const filterValueTime = filterLocalDateAtMidnight.getTime();
                    if (cellValueTime === filterValueTime) {
                        return 0;
                    }
                    if (cellValueTime < filterValueTime) {
                        return -1;
                    }
                    if (cellValueTime > filterValueTime) {
                        return 1;
                    }
                },
                buttons: ['reset', 'apply'],
                closeOnApply: true,
                closeOnClear: true,
                suppressAndOrCondition: true,
                browserDatePicker: true,
                filterOptions: ['equals', 'lessThan', 'greaterThan'],
            };
        }
        case FieldTypeEnum.NUMBER: {
            return {
                buttons: ['reset', 'apply'],
                closeOnApply: true,
                closeOnClear: true,
                suppressAndOrCondition: true,
                filterOptions: ['equals', 'lessThan', 'greaterThan'],
            };
        }
        default: {
            return {
                buttons: ['reset', 'apply'],
                closeOnApply: true,
                closeOnClear: true,
                suppressAndOrCondition: true,
                filterOptions: ['contains', 'equals'],
            };
        }
    }
}
